import {
  DisabledFieldReason,
  IConversionTotals
} from 'store/modules/report/types'
import { isFieldDisabled } from './reportDisabledFields'

export const CONVERSION_UNAVAILABLE_MESSAGE =
  'Sem contagem de pessoas no período.'

export const CONVERSION_EXPLANATION =
  'Vendas efetivas ÷ pessoas que entraram na loja no período. Considera só as lojas com contagem de pessoas.'

// Mesma conta do chip de conversão da loja: vendas ÷ visitantes, em %.
// Sem visitantes contados não há taxa.
export const getConversionRate = (
  conversion?: IConversionTotals | null
): number | undefined =>
  conversion?.visitors
    ? (conversion.sales / conversion.visitors) * 100
    : undefined

export const formatConversionRate = (rate: number): string =>
  `${rate.toFixed(1).replace('.', ',')}%`

// Colunas "Pessoas" e "Conversão" das planilhas. A conversão vai como fração
// para a célula usar o formato 0.00%. As vendas podem chegar como '-' quando a
// linha não tem vendas disponíveis.
export const getConversionExportValues = (
  conversion: { sales: number | string, visitors: number } | null | undefined,
  salesDataReason?: DisabledFieldReason
): (number | string)[] => {
  if (!conversion) return ['-', '-']

  const { sales, visitors } = conversion
  const hasRate = !isFieldDisabled(salesDataReason) &&
    typeof sales === 'number' &&
    visitors > 0

  return [visitors, hasRate ? (sales as number) / visitors : '-']
}

// Cor da loja comparada à conversão do recorte (regional ou todas as lojas).
export const getConversionColor = (
  rate: number,
  referenceRate?: number
): string => {
  if (!referenceRate) return '#757575'
  if (rate >= referenceRate) return '#59ac2a'
  if (rate >= referenceRate * 0.8) return '#f0b222'
  return '#f34455'
}
